"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireWildcard(require("../styled"));
var _loadingIndicator = _interopRequireDefault(require("../loadingIndicator"));
var _LightboxOverlayCloseButton = _interopRequireDefault(require("./LightboxOverlayCloseButton"));
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Image = _styled.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 90vw;\n  max-height: 90vh;\n  cursor: pointer;\n"])));
var Container = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n\n  ", ", ", " {\n    transition: opacity 0.2s;\n    opacity: ", ";\n  }\n"])), Image, _LightboxOverlayCloseButton.default, (0, _styled.ifProp)('loaded', 1, 0));
var StyledLoader = (0, _styled.default)(_loadingIndicator.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: ", ";\n  transition: opacity 0.2s;\n"])), (0, _styled.ifProp)('loaded', 0, 1));
var loaderColor = (0, _styled.prop)('theme.overlay.lightbox.loader');
var LightboxOverlayImage = /*#__PURE__*/function (_Component) {
  function LightboxOverlayImage() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loaded: false
    };
    _this.setImageRef = function (ref) {
      if (ref && _this.state.loaded === false) {
        var isLoaded = ref.complete && ref.naturalHeight !== 0;
        if (isLoaded) {
          _this.setState({
            loaded: isLoaded
          });
        }
      }
    };
    _this.onImageLoad = function () {
      if (!_this.state.loaded) {
        _this.setState({
          loaded: true
        });
      }
    };
    return _this;
  }
  (0, _inheritsLoose2.default)(LightboxOverlayImage, _Component);
  var _proto = LightboxOverlayImage.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/_react.default.createElement(Container, {
      loaded: this.state.loaded,
      className: this.props.className
    }, /*#__PURE__*/_react.default.createElement(_LightboxOverlayCloseButton.default, {
      onClick: this.props.setClosed
    }), /*#__PURE__*/_react.default.createElement(StyledLoader, {
      color: loaderColor,
      loaded: this.state.loaded
    }), /*#__PURE__*/_react.default.createElement(Image, {
      src: this.props.src,
      onClick: this.props.setClosed,
      ref: this.setImageRef,
      onLoad: this.onImageLoad
    }));
  };
  return LightboxOverlayImage;
}(_react.Component);
LightboxOverlayImage.defaultProps = {
  className: undefined
};
var _default = exports.default = LightboxOverlayImage;